/*
 * @Author: kangzhuang 742291831@qq.com
 * @Date: 2025-03-25 15:11:41
 * @LastEditors: kangzhuang 742291831@qq.com
 * @LastEditTime: 2025-04-16 13:17:14
 * @FilePath: \qrcode-web\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import "@/utils/element-ui";
import "@/styles/index.scss";
import { getToken, setToken, removeToken } from "@/utils/storage";
import api from "@/api/index";

Vue.prototype.$axios = axios;
/* axios.defaults.baseURL = "https://develop.himeit.com/api/admin"*/
Vue.config.productionTip = false;
Vue.prototype.$token = {
	get: getToken,
	set: setToken,
	remove: removeToken
};
Vue.prototype.$httpApi = api;

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount("#app");
